import axios from "axios";
import { API_CONFIG } from "../../config/main";

const BASE_URL = `${API_CONFIG.BASE_API_URL}${API_CONFIG.BASE_PATH}`;

export function fetchOffices() {
  const apiURL = `${BASE_URL}${API_CONFIG.END_POINTS.OFFICES.GET_ALL()}`;
  return axios
    .get(apiURL)
    .then((res) => {
      const success = res.status === 200;
      return {
        success: success,
        message: "Data fetched successfully.",
        data: res.data,
      };
    })
    .catch((err) => {
      return {
        success: false,
        message: err.response?.data?.errors
          ? err.response.data.errors.map((a) => a.detail).join(",")
          : err.response?.data?.message || "Network error. Please check your connection and try again.",
      };
    });
}
